import { gql } from 'apollo-angular';

export const queryWidget = gql`
  query getWidget($ID: String!) {
     Widget(ID: $ID) {
      ID
      name
      url
      content{
        page2{
          visioOption
          physicalOption
        }
      }
      options{
        hasVisio
        hasPhysical
        hasAmbassadorQuestion
        hasCommunityQuestion
      }
      questionsCommunity{
        ID
        product {
          name
        }
        tester{
          firstName
          lastName
        }
        object
        content
        responses {
          ambassadorID
          response
          responseDate
        }
        status
        _ {
          created
        }
      }
    }
  }
`;
